import { FormEvent, useState } from "react";
import { Loader2, Lock } from "lucide-react";
import { ApiError, SessionBootstrapResult, apiPost } from "../../api";

export function ResetPasswordScreen({
  csrfToken,
  bootstrapSession,
}: {
  csrfToken?: string;
  bootstrapSession: () => Promise<SessionBootstrapResult>;
}) {
  const token = new URLSearchParams(window.location.search).get("token") || "";
  const [password, setPassword] = useState("");
  const [password2, setPassword2] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [done, setDone] = useState(false);

  async function submit(event: FormEvent) {
    event.preventDefault();
    setSubmitting(true);
    setError(null);
    try {
      let csrf = csrfToken?.trim();
      if (!csrf) {
        const r = await bootstrapSession();
        if (!r.ok) {
          setError("Could not reach the server.");
          return;
        }
        csrf = r.session.csrfToken?.trim();
      }
      await apiPost("/api/account/reset-password", { token, password, password2 }, csrf);
      setDone(true);
    } catch (err) {
      setError(err instanceof ApiError ? err.message : "Could not reset the password.");
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="login-page">
      <div className="login-layout">
        <main className="login-main">
          <div className="login-card-wrap">
            <div className="login-title-wrap">
              <h1 className="login-title">Reset password</h1>
            </div>
            {done ? (
              <div className="login-card">
                <p className="login-step-note">Password saved. Sign in with the new password.</p>
                <a className="login-button" href="/login">
                  Sign in
                </a>
              </div>
            ) : (
              <form onSubmit={submit} className="login-card" autoComplete="off">
                {error ? <div className="login-error">{error}</div> : null}
                <div className="login-field">
                  <Lock className="login-field-icon" />
                  <input
                    type="password"
                    value={password}
                    onChange={(event) => setPassword(event.target.value)}
                    className="login-input"
                    placeholder="New password"
                    minLength={8}
                    required
                  />
                </div>
                <div className="login-field login-field-spaced">
                  <Lock className="login-field-icon" />
                  <input
                    type="password"
                    value={password2}
                    onChange={(event) => setPassword2(event.target.value)}
                    className="login-input"
                    placeholder="Confirm password"
                    minLength={8}
                    required
                  />
                </div>
                <button type="submit" disabled={submitting || !token} className="login-button">
                  {submitting ? <Loader2 className="h-4 w-4 animate-spin" /> : null}
                  Save password
                </button>
              </form>
            )}
          </div>
        </main>
      </div>
    </div>
  );
}
